/**
 * Auth utilities for cookie-based authentication
 * The httpOnly cookie is set by the backend - we only need to:
 * 1. Include credentials in requests
 * 2. Store non-sensitive user info in localStorage for UI purposes
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Configure axios defaults for cookie auth
export const configureAxiosAuth = (axios) => {
  axios.defaults.withCredentials = true;
};

// Store user info (non-sensitive) for UI purposes
export const setUserInfo = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('isAuthenticated', 'true');
};

// Get stored user info
export const getUserInfo = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

// Check if user appears to be authenticated (for UI purposes)
// Actual auth is verified by the httpOnly cookie on API calls
export const isAuthenticated = () => {
  return localStorage.getItem('isAuthenticated') === 'true';
};

// Clear local auth state
export const clearAuthState = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('isAuthenticated');
  // Note: The httpOnly cookie is cleared by calling /api/auth/logout
};

// Logout - clears cookie via API and local state
export const logout = async (axios) => {
  try {
    await axios.post(`${BACKEND_URL}/api/auth/logout`, {}, { withCredentials: true });
  } catch (err) {
    console.warn('Logout API call failed:', err);
  }
  clearAuthState();
};

// Verify auth status by calling /me endpoint
export const verifyAuth = async (axios) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/auth/me`, { 
      withCredentials: true 
    });
    setUserInfo(response.data);
    return { authenticated: true, user: response.data };
  } catch (err) {
    clearAuthState();
    return { authenticated: false, user: null };
  }
};

export default {
  configureAxiosAuth,
  setUserInfo,
  getUserInfo,
  isAuthenticated,
  clearAuthState,
  logout,
  verifyAuth
};
